
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { store, ShopModule, TradeInModule, CustomerModule } from "@returns-centre/store";
import { getModule } from 'vuex-module-decorators';
import { mixins } from 'vue-class-component';
import { FormatDateMixin } from '@returns-centre/mixins';
import { VueTimeline } from '@/components';
import { reverse } from 'lodash';

@Component({
    components: {
        VueTimeline
    }
})
export default class TradeInReturnTrackingView extends mixins(FormatDateMixin) {
    @Prop() tradeIn!: TradeIn;

    shopModule = getModule(ShopModule, store);
    tradeInModule = getModule(TradeInModule, store);
    customerModule = getModule(CustomerModule, store);

    get getReturnTracking(): VueTimelineItem[] {
        let tracking: VueTimelineItem[] = [];
        let self = this;
        this.tradeIn.shipment_tracking.forEach(function(item, index) {
            tracking.push({
                date: self.formatDate(item.status_updated_at, 'MMMM D, YYYY'),
                time: self.formatDate(item.status_updated_at, 'HH:mm a'),
                description: item.status_details,
                from: 'Admin',
                status: item.status,
                trackingLink: ''
            });
        });
        return reverse(tracking);
    }
}
